import { render } from "./CheckOrClose.vue?vue&type=template&id=b6050980&scoped=true"
import script from "./CheckOrClose.vue?vue&type=script&lang=js"
export * from "./CheckOrClose.vue?vue&type=script&lang=js"

import "./CheckOrClose.vue?vue&type=style&index=0&id=b6050980&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6050980"]])

export default __exports__